import React,{useEffect,useState,useRef} from 'react';
import { LoadScript, Autocomplete } from "@react-google-maps/api";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TimePicker from "rc-time-picker";
import 'rc-time-picker/assets/index.css';
import {CallApi} from "../common/API/APi";
import moment from 'moment';
import Select from 'react-select';

import {success,error} from "../common/Toastify"; 

const EditPaidCustomerDetails = (props) => {
  const {editpaiddetailid,setEditpaiddetailid,setNotifyrole}=props;
  const [fromlocationvalue, setFromlocationvalue] = useState();
  const [tolocationvalue, setTolocationvalue] = useState();
  const [pickupselectedDate, setPickupSelectedDate] = useState(null);
  const [returnselectedDate, setReturnSelectedDate] = useState(null);
  const [pickuptime, setpickuptime] = useState();
  const [returntime, setreturntime] = useState();
  const [userdetails, setUserdetails] = useState();
  const [hourdropdown, setHourdropdown] = useState();
  const fromRef = useRef(null);
  const toRef = useRef(null);
  
    const onLoadFrom = (autocomplete) => {
      fromRef.current = autocomplete;
    };
    const onLoadTo = (autocomplete) => {
      toRef.current = autocomplete;
    };
    
    const onPlaceChangedFrom = () => {
      if (fromRef.current !== null) {
        const place = fromRef.current.getPlace();
        const location = place.geometry?.location;
        if (location) {
          const fromlat = location.lat();
          const fromlng = location.lng();
          const locationName = place.formatted_address || place.name;
             setUserdetails(prevState => ({...prevState,'form_location':JSON.stringify({"lat":fromlat,'lang':fromlng}),'from_location_name':locationName}));
             setFromlocationvalue(locationName);
        }

      }
    };
  
    const onPlaceChangedTo = () => {
      if (toRef.current !== null) {
        const place = toRef.current.getPlace();
        const location = place.geometry?.location;
        if (location) {
          const tolat = location.lat();
          const tolng = location.lng();
          const locationName = place.formatted_address || place.name;
          setUserdetails(prevState => ({...prevState,'to_location':JSON.stringify({"lat":tolat,'lang':tolng}),'to_location_name':locationName}));
          setTolocationvalue(locationName);
        }
      }
    };
    const formatDate = (date) => {
      if (!date) return "";
      const year = String(date.getFullYear()).slice(-2); 
      const month = String(date.getMonth() + 1).padStart(2, "0"); 
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
   useEffect(()=>{
    if(editpaiddetailid){
      getdetails();
    }
   },[editpaiddetailid])

  const getdetails=async()=>{
         let res = await CallApi({"id":editpaiddetailid}, 'getorder-detailsbyid');
         if(res?.status === 200){
            setUserdetails(res?.data);
            setFromlocationvalue(res?.data?.from_location_name);
            setTolocationvalue(res?.data?.to_location_name);
            const parsedDate = moment(res?.data?.pikup_date, 'YY-MM-DD').toDate();
           setPickupSelectedDate(parsedDate);
           setpickuptime(moment(res?.data?.time, 'h:mm A').format("h:mm A"));
           if(res?.data?.book_return =="1"){
            const parsedDate = moment(res?.data?.returndate, 'YY-MM-DD').toDate();
            setReturnSelectedDate(parsedDate);
            setreturntime(moment(res?.data?.returntime, 'h:mm A').format("h:mm A"));
           }
           let array=[];
           for(let x=1; x<12;x++){
            array.push({'label':x,'value':x});
           }
           setHourdropdown(array);
         } else{
          error('Something went wrong');
         }
  }
  const updateuserdetails=async()=>{
    if(editpaiddetailid){
      if(!userdetails?.form_location){
        error("From location is not valid");
        return;
      }
      if(!userdetails?.to_location_name){
        error("To location is not valid");
        return;
      }
        const data={
            "order_id":editpaiddetailid,
            "form_location":userdetails?.form_location,
            "to_location":userdetails?.to_location,
            "from_location_name":userdetails?.from_location_name,
            "to_location_name":userdetails?.to_location_name,
            "pikup_date":formatDate(pickupselectedDate),
            "time":pickuptime,
            "returndate":formatDate(returnselectedDate),
            "returntime":returntime?returntime:'',
            "book_return":userdetails?.book_return,
            "type":userdetails?.type,
            "hour":userdetails?.hour
          };
    
         let res = await CallApi(data, 'updateorder-detailsbyid');
         if(res.status ==200){
          success(res?.message);
          setEditpaiddetailid('');
          setUserdetails('');
          setPickupSelectedDate(null);
          setReturnSelectedDate(null);
          setpickuptime('');
          setreturntime('');
          setFromlocationvalue('');
          setTolocationvalue('');
          setNotifyrole(current => !current);
          document.querySelector(".editusercancel").click();
         }else{
           error(res?.message);
         }
    }
        
  }

  return(
    <div className="modal fade com-modal" id="editcustomerdetailsmodel" tabIndex="-1" aria-labelledby="editcustomerdetailsmodelLabel" aria-hidden="true">
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h1 className="modal-title fs-5 golden-text" id="editcustomerdetailsmodelLabel">Edit Customer details</h1>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div className="modal-body pb-0">
       
          <div className='row'>
          <LoadScript
              googleMapsApiKey="AIzaSyDMOlp7YxbNLDJTDf3ButNrYkoY0Kq-xeA"
              libraries={["places"]}
            >
              <div className='col-md-12 mb-4'>
                <label className="mb-1">From Location:</label>
                <Autocomplete onLoad={onLoadFrom}  onPlaceChanged={onPlaceChangedFrom} fields={["geometry", "formatted_address", "name"]}>
                  <input
                   className=' com-input-field  pac-target-input'
                   value={fromlocationvalue}
                    type="text"
                    placeholder="Search a location"
                    style={{ width: "100%", height: "40px", padding: "8px" }}
                    onChange={(e)=>setFromlocationvalue(e.target.value)}
                  />
                </Autocomplete>
              </div>

              <div className='col-md-12 mb-4'>
                <label className="mb-1">To Location:</label>
                <Autocomplete onLoad={onLoadTo} onPlaceChanged={onPlaceChangedTo} fields={["geometry", "formatted_address", "name"]}>
                  <input
                    className='com-input-field '
                    value={tolocationvalue}
                    type="text"
                    placeholder="Search a location"
                    style={{ width: "100%", height: "40px", padding: "8px" }}
                    onChange={(e)=>setTolocationvalue(e.target.value)}
                  />
                </Autocomplete>
              </div>

            </LoadScript>
            <div className='col-md-12 mb-4 custom-full-width-date-time-picker'>
              <label className="d-block mb-1">Pickup Date</label>
               <DatePicker selected={pickupselectedDate} onChange={(date) => setPickupSelectedDate(date)} />
            </div>
            <div className='col-md-12 mb-4'>
              <label className="mb-1">Pickup Time</label>
              <TimePicker className="d-block " showSecond={false} minuteStep={5} use12Hours value={pickuptime ? moment(pickuptime, "h:mm A") : null}  format="h:mm A"  onChange={(value) => (value ? setpickuptime((moment(value).format("h:mm A"))):'')} clearIcon={null}  />
            </div>
            {userdetails?.type != 'home-tab'?
            <div className='col-md-12 mb-4'>
              <label className="mb-1">Hour</label>
              <Select
                  value={userdetails?.hour}
                  options={hourdropdown}
                  onChange={(e)=>{setUserdetails({...userdetails,hour:e})}}
                  isSearchable= {false}
                  placeholder=""
                />
            </div>
            :''}
        {userdetails?.book_return =="1"?
        <>
            <h4>Return Details</h4>

            <div className='col-md-12 mb-4 custom-full-width-date-time-picker'>
              <label className="mb-1; d-block">Return Date</label>
              <DatePicker   selected={returnselectedDate} onChange={(date) => setReturnSelectedDate(date)} />
            </div>
            <div className='col-md-12 mb-4 custom-full-width-date-time-picker'>
              <label className="mb-1 d-block">Return Time</label>
              <TimePicker className="d-block " showSecond={false} minuteStep={5} use12Hours   value={returntime ? moment(returntime, "h:mm A") : null} format="h:mm A" clearIcon={null}  onChange={(value) => (value ? setreturntime(moment(value).format("h:mm A")):'')} />
            </div>
            </>
            :''
        }

          </div>
 
        </div>
        <div className="modal-footer text-center">
          <button type="button" className="golden-bg font-13px com-btn golden-border" onClick={updateuserdetails} >Edit</button>
          <button type="button" className="golden-bg font-13px com-btn com-btn-outline golden-border bg-transparent editusercancel" data-bs-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
    </div>
  )
}
export default EditPaidCustomerDetails;